import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["content", "onClickCancel", "cancelButtonText", "onClickConfirm", "confirmButtonText", "disableConfirm"];
import React from 'react';
import PropTypes from 'prop-types';
import Dialog from './Dialog';

/*
 * Confirmation dialog component to confirm or cancel an action
 */
var ConfirmationDialog = function ConfirmationDialog(props) {
  var content = props.content,
    onClickCancel = props.onClickCancel,
    cancelButtonText = props.cancelButtonText,
    onClickConfirm = props.onClickConfirm,
    confirmButtonText = props.confirmButtonText,
    disableConfirm = props.disableConfirm,
    remainingProps = _objectWithoutProperties(props, _excluded);
  var footer = /*#__PURE__*/React.createElement("div", {
    className: "display-flex justify-content-end btn-toolbar"
  }, /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "CancelButton btn btn-default",
    onClick: onClickCancel
  }, cancelButtonText), /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "ConfirmationButton btn btn-primary",
    onClick: onClickConfirm,
    disabled: disableConfirm
  }, confirmButtonText));
  return /*#__PURE__*/React.createElement(Dialog, _extends({}, remainingProps, {
    body: content,
    footer: footer,
    onHide: onClickCancel,
    showCloseButton: false,
    className: "confirmation-dialog",
    disableEsc: true
  }));
};
ConfirmationDialog.defaultProps = {
  show: false,
  onClickCancel: function onClickCancel() {},
  onClickConfirm: function onClickConfirm() {}
};
ConfirmationDialog.propTypes = {
  show: PropTypes.bool.isRequired,
  title: PropTypes.node.isRequired,
  subtitle: PropTypes.node,
  content: PropTypes.node.isRequired,
  onClickCancel: PropTypes.func.isRequired,
  onClickConfirm: PropTypes.func.isRequired,
  cancelButtonText: PropTypes.node.isRequired,
  confirmButtonText: PropTypes.node.isRequired,
  disableConfirm: PropTypes.bool,
  bsSize: PropTypes.string
};
export default ConfirmationDialog;